<div class="editor-wrapper">
  <angular-editor
    [placeholder]="'Type here...'"
    [(ngModel)]="html"
    (ngModelChange)="onContentChange()"
  ></angular-editor>
</div>
